/**
 * Represente un état d'une étape de workflow.
 */
export class State {
    /**
     * Id de l'état
     */
    public id: number;

    /**
     * Nom de l'état.
     */
    public name: string;

    /**
     * Constructeur.
     */
    public constructor() {}

    /**
     * Retourne une copie d'une instance de State
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: State) {
        if (!!other) {
            const instance = new State();
            instance.id = other.id;
            instance.name = other.name;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de State
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: State[]) {
        if (!!others) {
            let states: State[] = [];

            others.forEach((x) => {
                const state = State.clone(x);
                states.push(state);
            });

            return states;
        } else {
            return [];
        }
    }
}
